import { Log } from './log'

export class Notify {
    static SUCCESS = 'success'
    static ERROR = 'error'
    static INFO = 'info'
    static WARNING = 'warning'
    static DEFAULT = 'default'

    static _subscribers = []

    static subscribe(callback) {
    	Notify._subscribers.push(callback)
    }

    static unsubscribe(callback) {
    	Notify._subscribers = Notify._subscribers.filter(subscriber => subscriber !== callback)
    }

    static _notify(type, message, log = false) {
    	Notify._subscribers.forEach(subscriber => subscriber(type, message))

    	if (log) {
    		Log._log(type, message)
    	}
    }

    static success(message, log = false) {
    	Notify._notify(Notify.SUCCESS, message, log)
    }

    static error(message, log = true) {
    	Notify._notify(Notify.ERROR, message, log)
    }

    static info(message, log = false) {
    	Notify._notify(Notify.INFO, message, log)
    }

    static warning(message, log = true) {
    	Notify._notify(Notify.WARNING, message, log)
    }

    static message(message, log = false) {
    	Notify._notify(Notify.DEFAULT, message, log)
    }
}